import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled(motion.div)`
  width: 100vw;
  height: 100svh;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, darkBackground }) =>
    darkBackground ? theme.color.darkGrey : 'transparent'};
  z-index: 10000000000000000;
  left: 0;
  top: 0;
`;

export const StyledPopup = styled(motion.div)`
  width: 334px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: ${({ theme }) => theme.color.white};
  padding: 30px 0 20px 0;
  border-radius: 8px;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.02), 0 -1px 6px 0 rgba(0, 0, 0, 0.06);
  ${({ popupStyles }) => popupStyles};

  ${({ $isSelectionMode, theme }) =>
    $isSelectionMode &&
    css`
      width: 400px;
      max-width: calc(100vw - 32px);
      align-items: stretch;
      padding: 28px 24px 22px;
      outline: none;
      border-radius: 20px;
      border: 1px solid ${theme.color.brightTurquoise};
      box-shadow: 0 12px 32px rgba(48, 70, 89, 0.14);
    `}

  & > button:first-of-type {
    position: absolute;
    right: 13px;
    top: 13px;
  }
`;

export const Header = styled.h1`
  color: ${({ theme }) => theme.color.pickledBluewood};
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  padding: 0 30px 20px 30px;
`;

export const Message = styled.p`
  white-space: pre-wrap;
  line-height: 20px;
  text-align: center;
  background: none;
  padding: 0 20px 30px 20px;
  font-weight: bold;
  font-size: 16px;
  ${({ theme }) => `
    color: ${theme.color.shark};
  `};

  ${({ $isSelectionMode, theme }) =>
    $isSelectionMode &&
    css`
      text-align: left;
      padding: 0;
      margin: 0 0 18px;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: -0.2px;
      color: ${theme.color.pickledBluewood};
    `}
`;

export const ButtonContainer = styled.div`
  display: grid;
  grid-row-gap: 10px;
  width: 100%;
  justify-items: center;
  ${({ buttonContainerStyles }) => buttonContainerStyles};
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin: 0 0 22px;
`;

export const RadioOption = styled.label<{ $checked?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 12px 14px;
  cursor: pointer;
  border-radius: 12px;
  border: 1.5px solid
    ${({ theme, $checked }) =>
      $checked ? theme.color.brightTurquoise : theme.color.porcelain};
  background-color: ${({ theme, $checked }) =>
    $checked ? theme.color.aquaSqueeze : theme.color.white};
  transition: background-color 0.18s ease, border-color 0.18s ease;

  &:hover {
    background-color: ${({ theme, $checked }) =>
      $checked ? theme.color.aquaSqueeze : theme.color.blackSqueeze};
    border-color: ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

export const RadioMark = styled.span`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.color.casper};
  box-sizing: border-box;
  position: relative;
  transition: border-color 0.18s ease;

  ${RadioInput}:checked + & {
    border-color: ${({ theme }) => theme.color.brightTurquoise};
  }

  ${RadioInput}:checked + &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ theme }) => theme.color.brightTurquoise};
    transform: translate(-50%, -50%);
  }
`;

export const RadioLabel = styled.span`
  color: ${({ theme }) => theme.color.pickledBluewood};
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const selectionActionButtonStyles = {
  width: 'auto',
  minWidth: '110px',
  padding: '0 22px',
};
